/**
 * 兼容性补丁
 * @description 为旧浏览器提供现代 JavaScript API 支持
 */

// 为 ObjectConstructor 添加 hasOwn 方法的类型声明
declare interface ObjectConstructor {
  hasOwn(obj: any, prop: string | symbol): boolean;
}

/**
 * 为 Object.hasOwn 添加补丁
 * @description 兼容旧浏览器（如360浏览器）不支持 Object.hasOwn 的问题
 */
if (!(Object as any).hasOwn) {
  (Object as any).hasOwn = function(obj: any, prop: string | symbol): boolean {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

/**
 * 为 String.prototype.padStart 添加补丁
 * @description 兼容旧浏览器不支持 padStart 方法的问题
 */
if (!String.prototype.padStart) {
  String.prototype.padStart = function(targetLength: number, padString: string = ' '): string {
    targetLength = targetLength >> 0;
    padString = String(padString || ' ');
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length);
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

/**
 * 为 String.prototype.padEnd 添加补丁
 * @description 兼容旧浏览器不支持 padEnd 方法的问题
 */
if (!String.prototype.padEnd) {
  String.prototype.padEnd = function(targetLength: number, padString: string = ' '): string {
    targetLength = targetLength >> 0;
    padString = String(padString || ' ');
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length);
      }
      return String(this) + padString.slice(0, targetLength);
    }
  };
}

/**
 * 为 Array.prototype.includes 添加补丁
 * @description 兼容旧浏览器不支持 includes 方法的问题
 */
if (!Array.prototype.includes) {
  Array.prototype.includes = function(searchElement: any, fromIndex: number = 0): boolean {
    if (this == null) {
      throw new TypeError('"this" is null or not defined');
    }
    const o = Object(this);
    const len = o.length >>> 0;
    if (len === 0) {
      return false;
    }
    const n = fromIndex | 0;
    let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
    while (k < len) {
      if (o[k] === searchElement) {
        return true;
      }
      k++;
    }
    return false;
  };
}
